export interface StudioRequest {
  id: string;
  taskId: string;
  status: string;
  taskCount: number;
  data: {
    sourceMediaId?: string;
    readyClips?: number;
    qcFailedClips?: number;
    error?: string;
    /** "segments" for an ad-blocks run (etap G); absent for classic clip production. */
    mode?: string;
    segments?: number;
  } | null;
  createdAt: string;
}

export const latestRequestsBySource = (requests: StudioRequest[]): Map<string, StudioRequest> => {
  const latest = new Map<string, StudioRequest>();
  for (const request of requests) {
    const sourceId = request.data?.sourceMediaId;
    if (!sourceId) continue;
    const previous = latest.get(sourceId);
    if (!previous || request.createdAt > previous.createdAt) latest.set(sourceId, request);
  }
  return latest;
};

export const isStudioRequestRunning = (request: StudioRequest | undefined): boolean =>
  request?.status === "STARTED" || (request?.status === "SCHEDULED" && request.taskId !== request.id);

/** Newest finished segment-mining request per source (etap G). */
export const latestSegmentRequestsBySource = (requests: StudioRequest[]): Map<string, StudioRequest> =>
  latestRequestsBySource(requests.filter((request) => request.data?.mode === "segments"));
